const ClearFilter = {
  data() {
    return {
      isActive: false
    }
  },
  methods: {
    handleClick: function() {
      bus.$emit('clearFilters')


      this.isActive = true

      setTimeout(() => {
        this.isActive = false
      }, 300);
    }
  }
}

export default ClearFilter
